import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  dialogContent: {
    width: "100%",
    fontFamily: "Manrope !important",
    flex: 1,
    flexDirection: "column",
    paddingBottom: "15px",
    alignItems: "center",
    justifyContent: "center",
  },
  subtitle: {
    font: "700 16px/24px Manrope",
    color: "#465869",
    marginBottom: "20px",
  },
  quantityDiv: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  tooltipError: {
    color: "#B42318 !important",
    backgroundColor: "#FEE4E2 !important",
  },
  tooltipDisabled: {
    color: "#FFFFFF !important",
    backgroundColor: "#93A9BD !important",
  },
  rightButton: {
    marginLeft: "10px",
  },
  modalBody: {
    width: "90vw !important",
  },
  sku: { width: "10%" },
  poNumber: { width: "10%" },
  description: { width: "15%" },
  originCriterion: { maxWidth: "50px" },
  hscode: { width: "20%" },
  volume: { width: "8%" },
  weight: { width: "8%" },
  quantity: { maxWidth: "50px" },
}));

export default styles;
